<template>
  <BaseModal>
    <div class="content">
      <h1>{{ $_translations.value.modal_register_via_sms_title }}</h1>

      <BaseImage src="/static/images/store/store_confirm_sms.svg" alt="Register" />

      <p>
        {{ $_translations.value.modal_register_via_sms_instructions_pt1 }}
        “<span
        class=yellow_bold>{{ $_translateByOperator('modal_register_via_sms_instructions_pt2') }}
      </span>”
        {{ $_translations.value.modal_register_via_sms_instructions_pt3 }}
        <span class=yellow_bold>
          {{ $_translateByOperator('modal_register_via_sms_instructions_pt4') }}
        </span>
      </p>

      <p>{{ $_translations.value.modal_register_via_sms_login_prompt_pt1 }}
        <a
          href="#"
          class=yellow_bold
          @click.prevent="$emit('redirect:loginPage')"
        >
          {{ $_translations.value.modal_register_via_sms_login_prompt_pt2 }}
        </a>
        {{ $_translations.value.modal_register_via_sms_login_prompt_pt3 }}
      </p>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';

defineEmits(['redirect:loginPage']);
</script>
